module.exports = __webpack_public_path__ + "img/pin-end.338bbfe5.svg";